import { FC, useMemo } from 'react';
import { useTimeDisplayFormat } from '@/entities/settings';
import { parseMarkedText } from '@/shared/lib';
import { CommentTextLines } from '../CommentTextLines';
import { ATTR_COMMENT_MARKERS } from '../commentMarkers';
import { MessageMarkLink } from '../MessageMarkLink';
import { TimeFragmentLink } from '../TimeFragmentLink';

type Props = { comment: string };

export const AttrCommentText: FC<Props> = ({ comment }) => {
  const timeDisplayFormat = useTimeDisplayFormat();
  const parts = useMemo(() => parseMarkedText(comment, ATTR_COMMENT_MARKERS), [comment]);

  return (
    <span>
      {parts.map((part, index) => {
        if (part.kind === 'text') return <CommentTextLines key={index} text={part.text} />;
        if (part.marker.type === 'message') return <MessageMarkLink key={index} sentAt={part.marker.sentAt} />;
        return <TimeFragmentLink key={index} time={part.marker.time} format={timeDisplayFormat} />;
      })}
    </span>
  );
};
